/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation == "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption == "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture == "none" || params.wainscotTexture == "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const storageRightWall = useMemo(() => {
        const meshStorageRightWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage_front) - 0.01)))
        const meshStorageRightDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanStorageRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        let meshStorageRightWainscotModel_Temp = meshStorageRightWainscotModel.clone();
        meshStorageRightWainscotModel_Temp.position.set(-params.leanF_p_d / 2, 3, -params.leanF_p_w + 0.2);
        meshStorageRightWainscotModel_Temp.rotation.y = Math.PI / 2;
        meshStorageRightWainscotModel_Temp.updateMatrixWorld();
    
        let meshStorageRightDelModel_Temp = meshStorageRightDelModel.clone();
        meshStorageRightDelModel_Temp.position.set( - params.frontLeanStoragePosition - params.leanF_p_pos, 0, -(params.leanF_p_w) + 0.5);
        meshStorageRightDelModel_Temp.rotation.y = Math.PI;
        meshStorageRightDelModel_Temp.updateMatrixWorld();

        const meshStorageRightWainscotModel_CSG = CSG.fromMesh(meshStorageRightWainscotModel_Temp);
        const meshStorageRightDelModel_CSG = CSG.fromMesh(meshStorageRightDelModel_Temp);
    
        const storageRightWainscotModel_CSG = meshStorageRightWainscotModel_CSG.subtract(meshStorageRightDelModel_CSG);

        const CSGStorageRightWainscotModel = CSG.toMesh(storageRightWainscotModel_CSG,new THREE.Matrix4());

        return CSGStorageRightWainscotModel.geometry;
    }, [params.leanF_p_d, params.leanF_p_w, params.add_storage_front, params.frontLeanStoragePosition, const_var.newDoorsArray, params.leanF_p_pos])

    return (
        <group position={[0, 0, params.p_d / 2 + params.leanF_p_w + 0.01]}>
            {params.p_w_c_n === true && params.add_storage_check_front && storageRightWall &&
                <mesh name="wainscotTrim" geometry={storageRightWall}>
                    <MaterialWainScotTrimNew   visibleSection={"frontLean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel